const INITIAL_STATE = {
    menuVisible: true
}

export default function Wrapper(state = INITIAL_STATE, action) {
    switch(action.type) {
        case 'MENU_OPEN' :
            return { ...state, menuVisible: !state.menuVisible }
        default :
            return state
    }
}